import { Role } from './team.service';

export class User {
    id = 0;
    filteredRoles = [];
    name = '';
    roles: Role[] = [];
    role: Role | '' = '';
    abbreviation = '';
    icon = '';
    email = '';
    username = '';
    password = '';
    activeCount = 0;
    overdueCount = 0;
    localId = 0;
    limited = [];
    settings = {};
    social = {};    // arbitrary key:value pairs containing social media links, plus bio (fallback bio) and bio_{site_id}"

    constructor(user: object) {
        for(var prop in user) {
            if( this.hasOwnProperty(prop) ) {
                this[prop] = user[prop];
            }
        }
    }
    getName() {
        return this.name;
    }
    getId() {
        return this.id;
    }
    getRole() {
        return this.role;
    }
    userCan(role) {
        // TODO: add reverse degredation
        return this.roles.indexOf(role) !== -1;
    }
}